.offcanvas {
  position: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
  top: 50px;
  left: 0;
  bottom: 0;
  z-index: 1050;
  width: 100%;
  max-width: 100vw;
  transition: transform 0.5s;
  transform: translate3d(-100%, 0, 0);
  background-color: var(--brand-offcanvas-background, #2A2A2A);
  font-size: 0.875rem;
}
.offcanvas-active .offcanvas {
  transform: translate3d(0, 0, 0);
}
.offcanvas.offcanvas-child-active {
  overflow-y: hidden;
}
@media (min-width: 768px) {
  .offcanvas {
    top: 80px;
  }
}
@media (min-width: 992px) {
  .offcanvas {
    display: none;
  }
}
.offcanvas uvex-accordion {
  margin-bottom: 0;
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-headline {
  background-color: unset;
  color: var(--brand-offcanvas-color, #ffffff);
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-headline:before, .offcanvas uvex-accordion uvex-collapse.show > .collapse-headline:after {
  background-color: var(--brand-primary, #FF6600);
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-headline:before {
  transform: rotate(225deg);
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-headline:after {
  transform: rotate(135deg);
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-headline.no-border {
  border-bottom: 1px solid var(--brand-offcanvas-color, #ffffff);
}
.offcanvas uvex-accordion uvex-collapse.show > .collapse-content {
  padding: 0.5rem 2.5rem 1rem 2.5rem;
}
.offcanvas uvex-accordion uvex-collapse .collapse-headline {
  background: none;
  border-bottom: 1px solid var(--brand-offcanvas-border-color, #666666);
  font-weight: 700;
  color: var(--brand-offcanvas-color, #ffffff);
  margin: 0 1rem;
  padding: 0.75rem 2rem 0.75rem 0;
  font-size: 0.875rem;
  line-height: 1.3125rem;
}
.offcanvas uvex-accordion uvex-collapse .collapse-headline:before, .offcanvas uvex-accordion uvex-collapse .collapse-headline:after {
  content: "";
  height: 2px;
  position: absolute;
  right: 0.5rem;
  top: 1.3125rem;
  transform: rotate(0deg);
  transition: border 0.25s, transform 0.25s, background-color 0.25s;
  will-change: transform;
  width: 1rem;
  background-color: var(--brand-offcanvas-color, #ffffff);
}
.offcanvas uvex-accordion uvex-collapse .collapse-headline:before {
  transform: rotate(90deg);
}
.offcanvas uvex-accordion uvex-collapse .collapse-headline.no-border {
  border-bottom: 0;
}
.offcanvas uvex-accordion uvex-collapse .collapse-headline:hover {
  background-color: unset;
  color: var(--brand-offcanvas-color, #ffffff);
}
.offcanvas uvex-accordion uvex-collapse .collapse-content {
  color: #fff;
}
.offcanvas uvex-accordion uvex-collapse .collapse-content ul {
  margin-top: 0;
  padding-left: 0;
  list-style: none;
}
.offcanvas uvex-accordion .collapse-content ul:not(.flyout-buttons) a,
.offcanvas uvex-accordion .offcanvas-link {
  border-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  padding: 0.5rem 0 0.5rem 0;
}
.offcanvas picture {
  max-width: 350px;
}
@media (min-width: 768px) {
  .offcanvas picture {
    max-width: 492px;
  }
}
.offcanvas picture.ratio-picture {
  width: auto;
}
.offcanvas picture.ratio-picture:before {
  display: none;
}
.offcanvas picture.ratio-picture img {
  position: relative;
  width: var(--width, 100%);
}
.offcanvas .hico {
  position: relative;
  border-top: 2px solid var(--brand-offcanvas-divider-color, #ffffff);
  margin: 2rem 1rem 1rem 1rem;
  padding-top: 2rem;
}
.offcanvas .hico:before {
  content: "";
  position: absolute;
  top: -35px;
  height: 2px;
  width: 100%;
  background-color: var(--brand-offcanvas-background, #2A2A2A);
}
@media (min-width: 768px) {
  .offcanvas .hico {
    border-top: 0;
    margin: 0;
    padding-top: 0;
  }
  .offcanvas .hico:before {
    content: "";
    position: absolute;
    top: 0;
    left: -1rem;
    width: 2px;
    height: 100%;
    background-color: var(--brand-offcanvas-divider-color, #ffffff);
  }
}
.offcanvas .hico picture {
  padding: 0 1rem;
  margin-top: 1rem;
  width: 100%;
  display: block;
}
@media (max-width: 767px) {
  .offcanvas .hico picture {
    padding: 0;
  }
}
.offcanvas .hico picture + picture {
  margin-top: 0;
}
.offcanvas .hico img {
  margin-bottom: 1rem;
}
@media (max-width: 767px) {
  .offcanvas .hico .offcanvas-link,
  .offcanvas .hico uvex-accordion uvex-collapse .collapse-headline,
  .offcanvas .hico ul:not(.flyout-buttons) li {
    margin: 0;
  }
}
.offcanvas .hico :last-child {
  border-bottom: 0;
}
.offcanvas .flyout-buttons {
  margin-top: 0;
  padding-left: 2.5rem;
}
.offcanvas .flyout-buttons li {
  margin-bottom: 0.625rem;
}
.offcanvas .flyout-buttons a {
  background-color: #666;
  color: #fff;
}
.offcanvas p {
  color: #fff;
}
.offcanvas ul:not(.flyout-buttons) {
  list-style: none;
  margin: 0;
  padding: 0;
}
.offcanvas ul:not(.flyout-buttons) li {
  margin: 0 1rem;
  padding: 0.75rem 1rem 0.75rem 0;
  color: #fff;
  border-bottom: 1px solid var(--brand-offcanvas-border-color, #666666);
}
.offcanvas ul:not(.flyout-buttons) a {
  color: #fff;
  display: block;
}

.collapse-content ul:not(.flyout-buttons) li {
  margin: 0;
  padding: 0;
  border-bottom: 0;
}

.collapse-content ul:not(.flyout-buttons) a,
.offcanvas-back,
.offcanvas-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem 0.75rem 0;
  border-bottom: 1px solid var(--brand-offcanvas-border-color, #666666);
  position: relative;
  color: var(--brand-offcanvas-color, #ffffff);
}
.collapse-content ul:not(.flyout-buttons) a svg,
.offcanvas-back svg,
.offcanvas-link svg {
  display: var(--brand-offcanvas-globe-display, none);
  margin-right: 1rem;
}
.collapse-content ul:not(.flyout-buttons) a, .collapse-content ul:not(.flyout-buttons) a:hover, .collapse-content ul:not(.flyout-buttons) a:focus,
.offcanvas-back,
.offcanvas-back:hover,
.offcanvas-back:focus,
.offcanvas-link,
.offcanvas-link:hover,
.offcanvas-link:focus {
  color: var(--brand-offcanvas-color, #ffffff);
}
.collapse-content ul:not(.flyout-buttons) a.active,
.offcanvas-back.active,
.offcanvas-link.active {
  color: var(--brand-primary, #FF6600);
}

.offcanvas-back {
  background: var(--brand-offcanvas-background, #2A2A2A);
  border-bottom: 0;
  font-weight: 700;
  border-bottom: 2px solid var(--brand-offcanvas-divider-color, #ffffff);
  padding-left: 2rem;
  margin: 0 1rem;
  height: 47px;
}

uvex-offcanvas-next:before,
uvex-offcanvas-prev:before {
  content: "";
  position: absolute;
  display: block;
  width: 0.75rem;
  height: 0.75rem;
  border-top: 3px solid var(--brand-offcanvas-arrow-next-color, #666666);
  border-right: 3px solid var(--brand-offcanvas-arrow-next-color, #666666);
}

uvex-offcanvas-next {
  padding-right: 1.5rem;
}
uvex-offcanvas-next:before {
  right: 1rem;
  transform: rotate(45deg);
}

uvex-offcanvas-prev {
  padding-left: 1.5rem;
}
uvex-offcanvas-prev:before {
  left: 0;
  transform: rotate(225deg);
  border-top: 3px solid var(--brand-offcanvas-arrow-prev-color, #ffffff);
  border-right: 3px solid var(--brand-offcanvas-arrow-prev-color, #ffffff);
}

.collapse-content ul:not(.flyout-buttons) a,
.offcanvas-link {
  margin: 0 1rem;
  border-bottom: 1px solid var(--brand-offcanvas-border-color, #666666);
}

.offcanvas-divider {
  display: var(--brand-offcanvas-divider-display, block);
  margin: 0 1rem 2rem 1rem;
  border-bottom: 2px solid var(--brand-offcanvas-divider-color, #ffffff);
  padding-top: 2rem;
  background-color: var(--brand-offcanvas-background, #2A2A2A);
  position: relative;
  top: -1px;
}

.offcanvas-level-1,
.offcanvas-level-2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: transform 0.5s;
  transform: translate3d(-100%, 0, 0);
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  background-color: var(--brand-offcanvas-background, #2A2A2A);
  z-index: 1;
  padding-bottom: 50px;
}
.offcanvas-level-1.offcanvas-item-active,
.offcanvas-level-2.offcanvas-item-active {
  display: block;
  overflow-x: hidden;
  transform: translate3d(0, 0, 0);
}
.offcanvas-level-1.offcanvas-child-active,
.offcanvas-level-2.offcanvas-child-active {
  overflow-y: hidden;
}

.offcanvas-level-2 {
  z-index: 2;
}

.offcanvas-flyout {
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .offcanvas-flyout {
    padding-top: 1rem;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .offcanvas-flyout .offcanvas-flyout-left {
    width: calc(50% - 1rem);
    flex: 0 0 calc(50% - 1rem);
  }
  .offcanvas-flyout .hico {
    width: calc(50% - 1rem);
    flex: 0 0 calc(50% - 1rem);
  }
}
.offcanvas-flyout .offcanvas-flyout-left .menuimage {
  display: none;
}
.offcanvas-flyout .hico > .offcanvas-link,
.offcanvas-flyout .offcanvas-flyout-left > .offcanvas-link {
  font-weight: 700;
}